
import { Component } from '@angular/core';

@Component({
    selector: 'app-server',
    templateUrl: './server.component.html',
    styles: [`
        .online {
            color: white;
        }
        .offline {
            color: yellow;
        }
    `]
})
export class ServerComponent {

    serverId: number = 10;
    serverStatus: string = 'offline';
    
    constructor() {
        this.serverStatus = Math.random() > 0.5 ? 'online' : 'offline';
    }

    getServerStatus(): string {
        return this.serverStatus;
    }

    getColor(): string {
        return this.getServerStatus() === 'online' ? 'green' : 'red';
    }

  ngOnInit(): void {
  }

}
